import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { BackToMenu } from "../features/menu/back-link";
import { ItemFormView } from "../features/menu/item-form";
import { useInPanes } from "../features/menu/panes";
import { Require } from "../features/require";

export const Route = createFileRoute("/menu/items/$itemId")({ component: Page });

function Page() {
	const { itemId } = Route.useParams();
	const navigate = useNavigate();
	const inPanes = useInPanes();
	return (
		<Require permission="menu.edit">
			<div className="max-w-3xl">
				<ItemFormView
					key={itemId}
					itemId={itemId}
					back={<BackToMenu />}
					onSaved={() => {
						if (!inPanes) void navigate({ to: "/menu" });
					}}
					onDeleted={() => void navigate({ to: "/menu", search: (prev) => prev })}
				/>
			</div>
		</Require>
	);
}
